var ManageRequestModule = (function () {
    function ManageRequestModule() {
    }
    return ManageRequestModule;
}());
export { ManageRequestModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request.module.ts.pre-build-optimizer.js